<template>
    <div class="well well-no-shadow p-0 col span_12 mb-5 ml-0">
        <div class="flex-level p-3">
            <p class="bold mb-0 mt-0">{{ titleAccount }}</p>
        </div>

        <!-- NOT SETUP YET -->
        <div v-if="!isSetup">
            <div class="flex-level p-3 bt-1">
                <!-- left column content -->
                <div class="wp-7">
                    <p class="bold mb-1 mt-0">{{ $l10n.__('Configuration') }}</p>
                    <p v-if="isAdmin & !isEmailsSentFromCorp" class="my-0">
                        {{
                            $l10n.__(
                                'Nous vous invitons à configurer le service email et choisir un mode (synchronisation ou transfert) afin de pouvoir envoyer vos emails depuis Sellsy.',
                            )
                        }}
                    </p>
                    <p v-else class="my-0">
                        {{
                            $l10n.__(
                                'Nous vous invitons à configurer le service email et choisir un mode (synchronisation ou transfert) afin de pouvoir envoyer vos emails depuis Sellsy.',
                            )
                        }}
                    </p>
                    <p class="mb-0 mt-1">
                        <a
                            href="https://help.sellsy.com/"
                            target="_blank"
                            class="link mb-0 mt-0 fs-3"
                            >{{ $l10n.__('En savoir plus') }}</a
                        >
                    </p>
                </div>
                <!-- right column action -->
                <div class="flex-item-right">
                    <router-link
                        v-if="isAdmin || !isEmailsSentFromCorp"
                        :to="{ name: 'onboarding.email' }"
                    >
                        <CompassButton :label="$t.__('email.configure_email_service')" />
                    </router-link>
                </div>
            </div>
        </div>

        <!-- SETUP -->
        <div v-else>
            <!-- Sync mode -->
            <EmailSettingsAccountModeSync
                v-if="isSyncMode"
                v-bind="account"
                :isEmailsSentFromCorp="isEmailsSentFromCorp"
            />
            <!-- Transfer mode -->
            <EmailSettingsAccountModeTransfer
                v-else
                v-bind="account"
                :isEmailsSentFromCorp="isEmailsSentFromCorp"
                :selectedProvider="provider"
            />
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import EmailSettingsAccountModeTransfer from './EmailSettingsAccountModeTransfer.vue';
import EmailSettingsAccountModeSync from './EmailSettingsAccountModeSync.vue';

const { mapState: mapStateUser, mapActions: userMapActions } = createNamespacedHelpers('user');

export default {
    name: 'EmailSettingsAccount',
    components: {
        EmailSettingsAccountModeTransfer,
        EmailSettingsAccountModeSync,
    },
    data() {
        return {
            account: null,
            emailPrefs: null,
        };
    },
    computed: {
        ...mapStateUser({
            isAdmin: 'isAdmin',
        }),
        /**
         * Return true if is Setup
         */
        isSetup() {
            return this.account.isSetup === 'Y';
        },
        /**
         * Return true if is Sync mode
         */
        isSyncMode() {
            return this.account.isNylas === 'Y';
        },
        /**
         * Return true if emails are send by corporation
         */
        isEmailsSentFromCorp() {
            return this.emailPrefs.emailsSentFromCorp === 'Y';
        },
        /**
         * Return the correct title of section
         */
        titleAccount() {
            const typeAccount = this.isEmailsSentFromCorp
                ? this.$l10n.__('Compte société')
                : this.$l10n.__('Compte collaborateur');
            return this.isSetup ? `${typeAccount} / ${this.account.modeName}` : typeAccount;
        },
        /**
         * Return the provider selected during configuration
         */
        provider() {
            return this.emailPrefs.onboarding_provider;
        },
    },
    created() {
        this.account = JSON.parse(this.$attrs.account);
        this.emailPrefs = JSON.parse(this.$attrs.emailprefs);
        this.updateIsOnboardingSetup(this.emailPrefs?.onboarding_setup === 'Y');
        if (this.account.verificationEmailSent) {
            this.$pushToast({
                type: this.account.verificationEmailSent.type,
                text: this.account.verificationEmailSent.message,
                close: true,
                icon: true,
                unique: true,
                timeout: 4000,
            });
        } else if (this.account.emailVerificationStatus) {
            let message = this.$l10n.__('Adresse email vérifiée');
            if (this.account.emailVerificationStatus === 'error') {
                message = this.$l10n.__(
                    "Échec de vérification de l'adresse email, merci de réessayer",
                );
            } else if (this.account.emailVerificationStatus === 'expired') {
                message = this.$l10n.__('Ce lien de validation est expiré, veuillez réessayer');
            }
            this.$pushToast({
                type: this.account.emailVerificationStatus === 'success' ? 'success' : 'error',
                text: message,
                close: true,
                icon: true,
                unique: true,
                timeout: 4000,
            });
        }

        this.updatePendingEmail(this.account.pendingEmail);
        this.updateEmailIsVerified(this.account.isVerified === 'Y');
    },
    methods: {
        ...userMapActions([
            'updatePendingEmail',
            'updateEmailIsVerified',
            'updateIsOnboardingSetup',
        ]),
    },
};
</script>
